import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, KeyValues20, KeyValueSet, KeyValueSets, LocalService, NumericConfig, QrLabelVariableType, Status, TriggeredEvent } from 'src/service/local.service';
import { QrlabelService } from 'src/service/qrlabel.service';

@Component({
  selector: 'app-label-variable-config',
  templateUrl: './label-variable-config.component.html',
  styleUrl: './label-variable-config.component.scss'
})
export class LabelVariableConfigComponent {
  QrLabelVariableType = QrLabelVariableType;

  @ViewChild('content_label_variable_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["qr_label_gen"];

  @Input() templateId: string = ''; @Input() id: string = ''; @Input() variableTypes: KeyValueSet[] = [];
  @Input() dynamicValuesFrom: KeyValueSet[] = []; @Input() languages: KeyValueSet[] = [];
  @Input() fontOptions: KeyValueSets[] = []; fontNames: KeyValueSet[] = []; @Input() customFields: KeyValueSet[] = [];

  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  numericConfigWithoutDecimal: NumericConfig = { isDecimalAllowed: false } as NumericConfig;
  numericConfigIncludeNegative: NumericConfig = { isNegativeAllowed: true } as NumericConfig;

  htmlId: string = ''; elementIds: any; item: KeyValues20; isWrap: boolean = false;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private qrlabelService: QrlabelService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      title: 'title_' + this.htmlId,
      type: 'type_' + this.htmlId,
      disp_text: 'disp_text_' + this.htmlId,
      value_from: 'value_from_' + this.htmlId,
      size: 'size_' + this.htmlId,
      x_pos: 'x_pos_' + this.htmlId,
      y_pos: 'y_pos_' + this.htmlId,
      language: 'language_' + this.htmlId,
      is_veritcal: 'is_veritcal_' + this.htmlId,
      font: 'font_' + this.htmlId,
      sample_text: 'sample_text_' + this.htmlId,
      rot_pos: 'rot_pos_' + this.htmlId,
      bar_scale: 'bar_scale_' + this.htmlId,
      span_width: 'span_width_' + this.htmlId,
      span_height: 'span_height_' + this.htmlId,
      custom_field: 'custom_field_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onInitiate();
  }

  onInitiate() {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.qrlabelService.getQrLabelVariable(this.templateId, this.id).subscribe(result => {
      this.item = result;
      this.isWrap = this.item.v16 == '1' ? true : false;
      this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
    }
  }

  onSave() {
    this.item.v16 = this.isWrap ? '1' : '0';
    this.qrlabelService.saveQrLabelVariable(this.item).subscribe(result => {
      this.localService.showInformationByStatus(result.status);

      if (result.status == Status.Success) {
        this.onCloseTrigger({ event: TriggeredEvent.Ok });
      }
    });
  }

  onSelectLanguage() {
    const item = this.fontOptions.find(x => x.key == this.item.v6);
    this.fontNames = item ? item.value : [];
    this.item.v7 = item && item.selectedValueKey ? item.selectedValueKey : '';
  }

  onRemoveLanguage() {
    this.fontNames = [];
    this.item.v7 = '';
  }

  onSelectType() {

  }
}
